<template>
  <div>
    <div class="cloudStorageGcp-title">
      <div>{{ $t("RAM.GCP.CloudStorageGcp.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:cloudStorageGcp:update'
          ]"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:gcp:cloudStorageGcp:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="cloudStorageGcp-top">
      <cloud-storage-gcp-search
        ref="cloudStorageGcpSearchChild"
      ></cloud-storage-gcp-search>
    </div>
    <table-cloud-storage-gcp></table-cloud-storage-gcp>
  </div>
</template>

<script>
import CloudStorageGcpSearch from "../cloudStorage/CloudStorageGcpSearch";
import TableCloudStorageGcp from "../cloudStorage/TableCloudStorageGcp";

export default {
  name: "CloudStorageGcp",
  components: {
    CloudStorageGcpSearch,
    TableCloudStorageGcp
  },
  data() {
    return {
      modal_loading: false,
      accountNameSearchID: "",
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.companyId = this.$refs.cloudStorageGcpSearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 400,
          accountType: 4
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      // 获取子组件数据
      this.companyId = this.$refs.cloudStorageGcpSearchChild.companyId;
      this.accountName = this.$refs.cloudStorageGcpSearchChild.accountName;
      this.resourceName = this.$refs.cloudStorageGcpSearchChild.resourceName;
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportGCPCloudStorage({
          companyId: this.companyId,
          accountName: this.accountName,
          resourceName: this.resourceName
        })
        .then(res => {
          let fileName = "CloudStorageGcp.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>

<style scoped>
.cloudStorageGcp-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.cloudStorageGcp-title > div:nth-child(1) {
  float: left;
}
.cloudStorageGcp-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.cloudStorageGcp-top {
  width: 100%;
  height: 53px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/gcp/cloudStorage/CloudStorageGcp.vue